import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  useHistory,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import AddEditCompany from "./AddEditCompany";
import CompanyDetaileStep from "../../../../assets/images/users.svg";
import LocationStep from "../../../../assets/images/navigation-green.svg";
import ContactStep from "../../../../assets/images/phone-green.svg";
import RefreedByStep from "../../../../assets/images/share-2-geen.svg";
import AddEditLocation from "./AddEditLocation";
import AddEditContact from "./AddEditContact";
import AddEditRefrredBy from "./AddEditRefrredBy";
import { createCompany, updateCompanyAPI } from "../../../../redux/adminSlice";
import toast from "react-hot-toast";

// export const icons = [CompanyDetaileStep, LocationStep, ContactStep, RefreedByStep];
export const icons = [
  { icon: CompanyDetaileStep, text: "Company Details" },
  { icon: LocationStep, text: "Location Details" },
  { icon: ContactStep, text: "Contact Details" },
  { icon: RefreedByStep, text: "Referred By" },
];

const CompanyStepProgressForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { step: urlStep, actionType: urlActionType, companyId } = useParams();
  // const [currentStep, setCurrentStep] = useState(Number(urlStep) || 1);
  const [currentStep, setCurrentStep] = useState(
    Number(urlStep) || (urlActionType === "edit" ? icons.length : 1)
  );
  const [actionType, setActionType] = useState(urlActionType || "add");
  // const [selectedProductId,setSelectedProductId] = useState('')
  // const location = useLocation();
  const [formData, setFormData] = useState({});
  // const [readyForSubmission, setReadyForSubmission] = useState(false);

  useEffect(() => {
    // Check if the current step is the last and the submission flag is true.
    console.log(" UseEffect Condition :::",currentStep < icons.length, currentStep,actionType,urlActionType)

    if (currentStep === 5 ) { //&& readyForSubmission
      console.log('Call in ',formData)
      handleSubmit(formData);
      // Reset the flag to prevent duplicate submissions.
      // setReadyForSubmission(false);
    }
  }, [currentStep,formData]);
  //readyForSubmission
   // Ensure this effect does not re - run unless necessary 
  const updateFormData = (stepData) => {
    // console.log("Final form data to updateForm:", stepData);

    setFormData((prevState) => ({
      ...prevState,
      ...stepData,
    }));
    console.log("updateFormData Condition :::",currentStep <= 4 , currentStep)
    if(actionType === "add"){
    setCurrentStep((prevStep) => prevStep + 1);
    }
    // else handleSubmit();
    
    // setCurrentStep(currentStep + 1)
    // console.log("Final form data to all data:", formData, currentStep);
  };
  const handleSubmit = () => {
    console.log('Call in submit',actionType,currentStep)
    if (actionType === "add" && currentStep === 5) {
      console.log("Dispatch create company action", actionType, formData);
      // navigate("/active-orders");
      dispatch(createCompany(formData))
        .then((response) => {
          console.log("RESPONSE :::",response)
          navigate('/active-orders');
          setFormData({});
          setCurrentStep(1);
        })
        .catch(error => console.error("Error creating company", error));
    }
    // if(actionType === "edit" && currentStep === 4) {
    //   console.log("Dispatch update company action", actionType, formData);
    //   dispatch(updateCompanyAPI(formData))
    //   .then((response) => {
    //     const companyDetails = response.payload
    //     console.log("companyDetails", companyDetails);

    //     if (companyDetails.success === true) {
    //       navigate(-1);
    //     } else {toast.error('Sonthing wen')

    //     }

    //   })
    //   .catch((error) => {
    //     console.error("Fetching user details error:", error);
    //   });}
  };

  const handleReset = () => {
    setFormData({});
    setCurrentStep(1);
  };
  // useEffect(() => {
  //     if (currentStep === 4) { // Assuming step 3 is the last step and submission should happen when transitioning to step 4
  //         console.log('Submitting form data:', formData, '\n currentStep :: ', currentStep);
  //         // dispatch(createBusinessUnit(formData))
  //         //     .then(() => {
  //         //         console.log("Business unit created successfully.");
  //         //         navigate('/business-unit')
  //         //         // Handle success, e.g., redirecting or showing a success message
  //         //     })
  //         //     .catch((error) => {
  //         //         console.error("Failed to register new user", error);
  //         //         // Handle error
  //         //     });
  //     }

  //     if (location.state?.actionType === 'edit' && currentStep !== null) { // Assuming step 3 is the last step and submission should happen when transitioning to step 4
  //         console.log('Editing Submitting form data:', formData);
  //         // navigate('/business-unit')

  //     }
  // }, [currentStep, formData, dispatch]);

  const handleStepChange = (stepNumber, action, productId = null) => {
    if (stepNumber >= 1 && stepNumber <= 4) {
      setCurrentStep(stepNumber);
      setActionType(action);
      // setSelectedProductId(productId);
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="step step-1 mt-3">
            {/* <h3>Company Details</h3> */}
            <AddEditCompany
              onSubmit={updateFormData}
              initialValues={formData.companyDetails}
              step="companyDetails"
              currentStep={currentStep}
              actionType={actionType}
            />
          </div>
        );
      case 2:
        return (
          <div className="step step-2  mt-3">
            {/* <h3>Location Details</h3> */}
            <AddEditLocation
              onSubmit={updateFormData}
              initialValues={formData.locationDetails}
              handleStepChange={handleStepChange}
              currentStep={currentStep}
              step="locationDetails"
              actionType={actionType}
            />
          </div>
        );
      case 3:
        return (
          <div className="step step-3  mt-3">
            {/* <h3>Contact Details</h3> */}
            <AddEditContact
              onSubmit={updateFormData}
              initialValues={formData.contactDetails}
              handleStepChange={handleStepChange}
              currentStep={currentStep}
              step="contactDetails"
              actionType={actionType}
            />
          </div>
        );
      case 4:
        return (
          <div className="step step-4  mt-3">
            {/* <h3>Refreed By</h3> */}
            <AddEditRefrredBy
              onSubmit={updateFormData}
              initialValues={formData.referredByDetails}
              handleStepChange={handleStepChange}
              currentStep={currentStep}
              step="referredByDetails"
              actionType={actionType}
            />
          </div>
        );
      default:
        return null;
    }
  };

  const updateProgressBar = () => ((currentStep - 1) / 3) * 100; // Calculate progress bar percentage
  console.log("Main Company Landing ::", actionType, currentStep, companyId);
  return (
    <>
      <div className="main-content">
        <nav aria-label="breadcrumb" className="bread-box">
          <div>
            <h1 className="fprimary">
              {actionType === "edit" ? "Edit company" : "Add company"}
            </h1>
            <h5 className="">
              {actionType === "edit" ? "Edit" : "Add"} Company details to create
              a new company
            </h5>
          </div>
          <div>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {actionType === "edit" ? "Edit" : "Add"} Company
              </li>
            </ol>
          </div>
        </nav>
        <div className="card mt-3 bg-stage">
          {actionType !== "edit" && (
            <div className="step-progress ps-5 pe-5">
              <div className="progress px-1" style={{ height: "3px" }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${updateProgressBar()}%` }}
                  aria-valuenow={updateProgressBar()}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <div className="step-container d-flex justify-content-between mb-5">
                {/* {icons.map((icon, index) => (
                                    <div key={index} className={`step-circle ${currentStep === index + 1 ? 'active' : ''}`} onClick={() => handleStepChange(index + 1)}><img src={icon} alt={`Step ${index + 1}`} /></div>
                                ))} */}
                {icons.map((step, index) => (
                  <div
                    key={index}
                    className={`step-circle ${currentStep === index + 1 ? "active" : ""
                      }`}
                    onClick={() => handleStepChange(index + 1)}
                  >
                    <img src={step.icon} alt={`Step ${index + 1}`} />
                    <span className="step-text">{step.text}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div id="multi-step-form">{renderStepContent()}</div>
        </div>
      </div>
    </>
  );
};

export default CompanyStepProgressForm;
